// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

export const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const APP_NAME = 'Cn-adm';
export const API_URL = import.meta.env.VITE_API_URL;
export const FILE_API = API_URL;
export const WALLET_API = API_URL;
export const BENEFITS_URL = API_URL;
export const PARTNERS_URL = API_URL;
export const MISSIONS_URL = API_URL;
export const TRAILS_URL = API_URL;
export const TIERS_URL = API_URL;
export const INVOICES_URL = API_URL;
export const ADVANCED_REPORTS_URL = import.meta.env.VITE_API_ADVANCED_REPORTS_URL;

export const SLIDER_BANNERS_ID = ['64592e0d7d61ae13415ba08a', '64592e147d61ae13415ba08c'];
export const TRANSACTION_IMAGE =
  'https://cidadecenternorte.com.br/wp-content/themes/babel-cidade-child/assets/images/shopping_center_norte.jpg';
